import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { integrations } from "../Integrations/IntegrationData";
import { BsArrowLeft } from "react-icons/bs";
export const IntegrationDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const app = integrations.find((i) => i.id === id);

  const [activeTab, setActiveTab] = useState("overview");

  if (!app) return <div>Not Found</div>;
  const redirectPath = `/integration/${app?.id}`;
  return (
    <div className="container mt-2">
      <div className="d-flex justify-content-between align-items-center ">
        <div className="d-flex align-items-center gap-3">
          <div>
            <h4 style={{ marginBottom: "2px", fontWeight: "600" }}>
              {app.name}
            </h4>
          </div>
        </div>
        <div className="d-flex gap-2 ">
          <button
            className="btn btn-default-outline "
            style={{ height: "36px" }}
            onClick={() => navigate("/settings/integration")}
          >
            <BsArrowLeft className="me-1" />
            Back
          </button>
          {app?.id === "facebook" ? (
           
            <button
              style={{ height: "36px" }}
              className="btn btn-default"
              onClick={() => navigate("/facebook_lead")}
            >
              Install App
            </button>
          ) : (<button
              style={{ height: "36px" }}
              className="btn btn-default"
              onClick={() => navigate(`${app.path}`)}
            >
              Install App
            </button>)
        }
        </div>
      </div>
      <div className="d-flex w-100 justify-content-between align-items-center">
        {/* //"permissions" add when need in array */}
        <div className="d-flex gap-4  pb-2 flex-grow-1">
          {["overview", "howItWorks"].map((tab) => (
            <div
              key={tab}
              onClick={() => setActiveTab(tab)}
              style={{
                cursor: "pointer",
                fontSize: "14px",
                fontWeight: activeTab === tab ? "600" : "400",
                color: activeTab === tab ? "#0d6efd" : "#555",
                borderBottom: activeTab === tab ? "2px solid #0d6efd" : "none",
                paddingBottom: "6px",
                transition: "0.2s",
              }}
            >
              {tab === "howItWorks"
                ? "How it will work"
                : tab.charAt(0).toUpperCase() + tab.slice(1)}
            </div>
          ))}
        </div>

        <div className="d-flex flex-column align-items-end gap-2 ms-3">
          {/* <button className="btn btn-primary btn-sm">
      Install App
    </button> */}
        </div>
      </div>

      <div
        style={{
          background: "#fff",
          borderRadius: "8px",
          padding: "20px",
          // marginTop: "15px",
          height: "500px",
          overflow: "scroll",
          boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
          scrollbarColor: " #aaafb3 #f3f3f3",
          scrollbarWidth: "thin",
        }}
      >
        {activeTab === "overview" && (
          <>
            <img
              src={app.logo}
              alt={app.name}
              style={{
                width: "150px",
                height: "100px",
                objectFit: "contain",
              }}
            />
            <div
            className="mt-1"
              style={{ color: "#444", lineHeight: "1.6", fontSize: "13px" }}
              dangerouslySetInnerHTML={{ __html: app.details?.overview }}
            />
          </>
        )}
        {activeTab === "howItWorks" && (
          <div>
            {Object.entries(app.details?.howItWorks || {}).map(
              ([section, items], idx) => {
                if (!items) return null;

                return (
                  <div key={idx} style={{ marginBottom: "20px" }}>
                    {/* Section Title */}
                    <div
                      style={{
                        fontWeight: "600",
                        marginBottom: "8px",
                        textTransform: "capitalize",
                      }}
                    >
                      {section.replace(/([A-Z])/g, " $1")}
                    </div>
                    {Array.isArray(items) && (
                      <ul style={{ paddingLeft: "18px" }}>
                        {items.map((item, i) => (
                          <li
                            key={i}
                            style={{ marginBottom: "6px", fontSize: "13px" }}
                          >
                            {item}
                          </li>
                        ))}
                      </ul>
                    )}
                    {typeof items === "string" && (
                      <p style={{ fontSize: "13px", color: "#444" }}>{items}</p>
                    )}
                    {typeof items === "object" && items?.type === "image" && (
                      <img
                        src={items.url}
                        alt="section"
                        style={{
                          width: "100%",
                          maxWidth: "400px",
                          borderRadius: "6px",
                          marginTop: "8px",
                        }}
                      />
                    )}
                  </div>
                );
              },
            )}
          </div>
        )}

        {/* {activeTab === "permissions" && (
          <div>
            <p style={{ fontWeight: "500" }}>
              It requests following permissions
            </p>

            <div className="row mt-3">
              {app?.details?.permissions?.map((perm, index) => (
                <div className="col-md-6 mb-3" key={index}>
                  <div className="d-flex align-items-start gap-2">
                    <span style={{ color: "green", fontSize: "18px" }}>✔</span>
                    <div>
                      <div style={{ fontWeight: "600" }}>{perm.name}</div>
                      <div style={{ fontSize: "13px", color: "#666" }}>
                        {perm?.access}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )} */}
      </div>
    </div>
  );
};
